export const VERSION = '1.4.4';
